import { hideAndRemoveInArr } from "./hideAndRemoveInArr";

export const hideAndRemoveAllActiveArrays = () => {
    for (const key in servObj) {
        const value = servObj[key];
        if (key.startsWith("active") && Array.isArray(value) && value.length > 0) {
            hideAndRemoveInArr(value);
        }
    }
};
